import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class DetailedEstimate extends Field {
  static subqueriesForModel() {
    return { originalEstimate: ['text'] };
  }

  get title() {
    return 'Detailed estimate';
  }

  exampleContents(): FieldContentsData {
    return { text: '4d', icon: { name: 'fa-regular fa-clock' } };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.originalEstimate?.text) {
      return {
        text: record.originalEstimate.text,
        icon: { name: 'fa-regular fa-clock' },
      };
    }

    return {};
  }
}
